/**
 * Logic Necessary for Tabs used in Inkwell CMS
 * List View
 * Author: Imarc 2019
 */
// Dependencies
import URI from 'urijs';

// DOM Nodes
const tabButtons = [...document.querySelectorAll('.js-tabSelect')];
const tabs = [...document.querySelectorAll('.js-tab')];
const url = new URI();

tabButtons.forEach(tabButton => {
    tabButton.addEventListener('click', function addClickEventToTabButton(event) {
        event.preventDefault();

        const dataTab = tabButton.dataset.tab;

        // update url with param
        url.setQuery({ tab: dataTab });
        // eslint-disable-next-line no-underscore-dangle
        window.history.pushState({}, document.title, URI.build(url._parts));

        tabButtons.forEach(tabSelect => {
            tabSelect.classList.remove('-active');
        });

        tabButton.classList.add('-active');

        tabs.forEach(tab => {
            if (tab.dataset.tab === dataTab) {
                tab.classList.add('-active');
            } else {
                tab.classList.remove('-active');
            }
        });
    });
});

window.addEventListener('popstate', function updateTabState() {
    const stateUrl = new URI(window.location.href);
    const dataTab = stateUrl.search(true).tab;

    tabs.forEach(tab => {
        if (tab.dataset.tab === dataTab) {
            tab.classList.add('-active');
        } else {
            tab.classList.remove('-active');
        }
    });

    tabButtons.forEach(tabSelect => {
        tabSelect.blur();
        tabSelect.classList.remove('-active');
    });

    tabButtons.forEach(tabButton => {
        if (tabButton.dataset.tab === dataTab) {
            tabButton.classList.add('-active');
        }
    });
});
